<template>
  <div class="page">
    <Header/>
    <div class="container dashboard card">
      <div class="card-header">
        {{ title }}
      </div>
      <div class="card-body">
        <div class="settings-container">
          <h3 class="settings-container-title" :class="{ opened: showLocals }" @click="showLocals = !showLocals">
            Local options
            <span class="small-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M0 384.7V127.3c0-17.8 21.5-26.7 34.1-14.1l128.7 128.7c7.8 7.8 7.8 20.5 0 28.3L34.1 398.8C21.5 411.4 0 402.5 0 384.7z"/></svg>
            </span>
          </h3>
          <div class="settings-container-item" :class="{ opened: showLocals }">
            <div class="settings-item"
                 v-for="item in localSettings"
                 v-bind:key="item.Name"
                 :data-item-id="item.Name"
            >
              <div v-if="item.Type==='bool'">
                <div class="settings-item-value">
                  <b-form-checkbox
                      :id="'checkbox-' + item.Name"
                      v-model="formLocalData[item.Name]"
                      :ame="'checkbox-' + item.Id"
                      value="true"
                      unchecked-value="false"
                      @change="changeLocalItem()"
                      class="form-control">
                    {{item.Title}}
                  </b-form-checkbox>
                </div>
                <span class="settings-item-description">{{item.Description}}</span><br />
              </div>

              <div v-if="item.Type==='int'">
                <div class="settings-item-name">
                  {{item.Title}}:
                </div>
                <div class="settings-item-value">
                  <b-input
                      :id="'checkbox-' + item.Name"
                      v-model="formLocalData[item.Name]"
                      type="number"
                      class="form-control"
                      @change="changeLocalItem()">
                  </b-input>
                </div>
                <span class="settings-item-description">{{item.Description}}</span><br />
              </div>

              <div v-if="item.Type==='select'">
                <div class="settings-item-name">
                  {{item.Title}}:
                </div>
                <div class="settings-item-value">
                  <b-form-select
                      v-model="formLocalData[item.Name]"
                      :options="item.Options"
                      :class="'short-select'"
                      @change="changeLocalItem()">
                  </b-form-select>
                </div>
                <span class="settings-item-description">{{item.Description}}</span><br />
              </div>
            </div>

            <div class="settings-block"><br /><br />
              <p>Change favicon (locally only)</p>
              <input
                  type="text"
                  class="form-control"
                  v-model="favicon"><br /><br />
              <button class="btn btn-default" type="button" @click="setIcon()" >Set icon</button>
            </div>
          </div>
          <h3 class="settings-container-title" :class="{ opened: showVars }" @click="showVars = !showVars">
            Server variables
            <span class="small-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M0 384.7V127.3c0-17.8 21.5-26.7 34.1-14.1l128.7 128.7c7.8 7.8 7.8 20.5 0 28.3L34.1 398.8C21.5 411.4 0 402.5 0 384.7z"/></svg>
            </span>
          </h3>
          <div class="settings-container-item" id="settings-container-item"
                  v-for="item in items"
                  v-bind:key="item.Id"
                  :data-item-id="item.Id"
                  :class="{ opened: showVars }"
          >
            <div v-if="item.Type==='string'">
              <div class="settings-item-name">
                {{item.Title}}: <span class="var-name">{{item.Name}}</span>
              </div>
              <div class="settings-item-value">
                <input
                        type="text"
                        class="form-control"
                        v-model="formData[item.Name].Value">
              </div>
              <span class="settings-item-description">{{item.Description}}</span>
            </div>

            <div v-if="item.Type==='int'">
              <div class="settings-item-name">
                {{item.Title}}:  <span class="var-name">{{item.Name}}</span>
              </div>
              <div class="settings-item-value">
                <input
                        type="number"
                        class="form-control"
                        v-model="formData[item.Name].Value">
              </div>
              <span class="settings-item-description">{{item.Description}}</span>
            </div>

            <div v-if="item.Type==='bool'">
              <div class="settings-item-value">
                <b-form-checkbox
                        :id="'checkbox-' + item.Id"
                        v-model="formData[item.Name].Value"
                        :ame="'checkbox-' + item.Id"
                        value="1"
                        unchecked-value="0"
                        class="form-control">
                  {{item.Title}}
                </b-form-checkbox> <span class="var-name">{{item.Name}}</span>
              </div>
              <span class="settings-item-description">{{item.Description}}</span>
            </div>

          </div>
          <button class="btn btn-default" type="button" @click="save()" >Save</button>
          <br /><br />
          <div class="settings-container-item settings-new-item-value">
            <label>New item name</label>
            <input
                type="text"
                class="form-control"
                id="new-name">
            <label>New item value</label>
            <input
                type="text"
                class="form-control"
                id="new-value">
            <label>New item title</label>
            <input
                type="text"
                class="form-control"
                id="new-title">
            <label>New item type</label>
            <select
                class="form-control"
                id="new-type">
              <option value="string">string</option>
              <option value="int">int</option>
              <option value="bool">bool</option>
            </select>
            <label>New item group</label>
            <select
                class="form-control"
                id="new-group">
              <option value="plugins">plugins</option>
              <option value="manager">manager</option>
              <option value="invoice-source">invoice-source</option>
            </select>
            <br /><br />
            <button class="btn btn-default" type="button" @click="append()" >Append</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import Header from './Header.vue';
  import {TokenMixin} from "@/assets/js/mixins/token-mixin";
  import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";
  export default {
    name: 'settings',
    mixins: [
      TokenMixin,
      ErrorsMixin,
    ],
    components: {
      Header
    },
    data() {
      return {
        filter: [],
        items: [],
        itemsCopy: [],
        formData: {},
        apiList: '/api/settings/list?sort=id',
        apiItem: '/api/settings/',
        pageTitle: 'Settings',
        title: 'Settings',
        theme: '',
        themes:[
          {'text':'Dark theme','value':'dark-theme'},
          {'text':'Light theme','value':'light-theme'},
        ],
        favicon: '',
        showLocals: true,
        showVars: true,
        localSettings: [
          {
            Title:'Timeout for start skip events by hidden tab (minutes)',
            Name:'skipEventsTime',
            Type:'int',
          },
          {
            Title:'Ignore events and actualize table data',
            Name:'eventsOffStatus',
            Type:'bool',
          },
          {
            Title:'Theme:',
            Name:'theme',
            Type:'select',
            Options: [
              {'text':'Dark theme','value':'dark-theme'},
              {'text':'Light theme','value':'light-theme'},
            ],
            Description: "If it`s changed, page will be reloaded and do not save other values",
          },
        ],
        formLocalData: [],
      };
    },
    methods: {
      LoadData() {
        console.log('LoadData');
        let loader = this.$loading.show();
        axios.post(this.apiList, this.filters, this.authRespConf())
                .catch((err) => {
                  loader.hide();
                  this.errorHandle(err, true, true);
                })
                .then(res => {
                  loader.hide();
                  console.log('loaded data');
                  this.items = res.data.data;
                  this.itemsCopy = res.data.data;

                  for (let itemIndex in this.items) {
                    this.formData[this.items[itemIndex].Name] = this.items[itemIndex];
                  }
                  console.log(this.formData);
                })
      },
      setTheme() {
        for (let index in this.themes) {
          document.getElementById('app').classList.remove(this.themes[index]['value']);
        }
        document.getElementById('app').classList.add(this.theme);
        localStorage.setItem('theme', this.theme);
        location.reload();
      },
      save() {
        console.log('save');
        console.log(this.formData);
        console.log(this.items);
        console.log(this.itemsCopy);

        for (let itemIndex in this.itemsCopy) {
          if (this.formData[this.itemsCopy[itemIndex].Name].Value !== null) {
            console.log('Change settings from', this.formData[this.items[itemIndex].Name].Value);
            console.log('Change settings to', this.itemsCopy[itemIndex].Value);

            axios.patch(
                    this.apiItem,
                    this.formData[this.itemsCopy[itemIndex].Name],
                    this.authRespConf())
                    .then(() => {
                      console.log('save ' + this.itemsCopy[itemIndex].Name);
                    })
                    .catch((err) => {
                      this.errorHandle(err, true, true);
                    });
          }
        }
      },
      setIcon() {
        if (this.favicon) {
          let link = document.querySelector("link[rel~='icon']");
          if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
          }
          link.href = this.favicon;
          localStorage.setItem('favicon', this.favicon);
        }
      },
      append() {
        let name = document.getElementById('new-name').value;
        let title = document.getElementById('new-title').value;
        let type = document.getElementById('new-type').value;
        let group = document.getElementById('new-group').value;
        let value = document.getElementById('new-value').value;
        if (this.formData[name] !== undefined || name === '') {
          return;
        }
        this.formData[name] = {
          Name: name,
          Value: value,
          Type: type,
          Group: group,
          Description: "",
          Title: title,
          UserId:0,
          Id:0
        }
        this.items.push(this.formData[name]);
        document.getElementById('new-name').value = "";
        document.getElementById('new-title').value = "";
        document.getElementById('new-value').value = "";
      },
      changeLocalItem() {
        for (let key in this.formLocalData) {
          localStorage.setItem(key, this.formLocalData[key]);
          console.debug("changeLocalItem", key, this.formLocalData[key], String(key));
        }
      },
    },
    created: function () {
      for (let v of this.localSettings) {
        this.formLocalData[v.Name] = localStorage.getItem(v.Name);
      }
      this.LoadData();
    },
    mounted: function () {
      this.favicon = localStorage.getItem('favicon');
    },
  }
</script>
<style>

.settings-container-title {
  cursor: pointer;
}

.settings-container-item {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease-out, padding 0.3s ease-out;
}

.settings-container-item.opened {
  max-height: fit-content;
}
.small-icon svg {
  height: 18px;
  vertical-align: middle;
  margin: 0 5px 3px 0;
}
.settings-container-title.opened .small-icon svg {
  rotate: 90deg;
}
.settings-block {
  padding: 6px 10px;
  border: 1px solid #878787;
}
.settings-item-value .form-control.custom-checkbox {
  padding: 0 0 10px 30px;
}
</style>
